import React, { useMemo } from 'react';
import { ResponsivePie } from '@nivo/pie';
import { useChartP2pVsCommerce } from '../../../hooks/useChartData';
import ChartCard from '../wrappers/ChartCard';
import nivoCustomTheme from '../theme/nivoCustomTheme';
import useResponsive from '../../../hooks/useResponsive';

const formatCLP = (v) => `$${Math.round(v).toLocaleString('es-CL')}`;

export default function P2PvsCommercePieChart({ dateFrom, dateTo, categoryIds }) {
  const { isMobile } = useResponsive();
  const { data, loading, error } = useChartP2pVsCommerce({ dateFrom, dateTo, categoryIds });

  const chartData = useMemo(
    () => data?.chartP2pVsCommerce ?? [],
    [data]
  );

  return (
    <ChartCard
      title="Transferencias P2P vs Comercios"
      subtitle="Distribución del gasto por tipo de destino"
      loading={loading && !data}
      error={error}
      height={320}
    >
      <ResponsivePie
        data={chartData}
        innerRadius={0.55}
        padAngle={2}
        cornerRadius={4}
        colors={['#26619C', '#FFD60A']}
        theme={nivoCustomTheme}
        margin={isMobile
          ? { top: 20, right: 40, bottom: 60, left: 40 }
          : { top: 20, right: 100, bottom: 60, left: 100 }
        }
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#3D4451"
        arcLinkLabelsThickness={2}
        arcLinkLabelsColor={{ from: 'color' }}
        arcLabelsSkipAngle={18}
        arcLabelsTextColor="#FFFFFF"
        valueFormat={formatCLP}
        tooltip={({ datum }) => (
          <div style={{ background: '#fff', padding: '8px 12px', borderRadius: 8, border: '1px solid #F0F0F0', boxShadow: '0 4px 20px rgba(38,97,156,0.12)', fontSize: 12, fontFamily: '"Inter", sans-serif' }}>
            <span style={{ display: 'inline-block', width: 10, height: 10, background: datum.color, borderRadius: 2, marginRight: 6 }} />
            <strong>{datum.label}</strong>: {formatCLP(datum.value)}
          </div>
        )}
        legends={[{
          anchor: 'bottom',
          direction: 'row',
          itemWidth: 130,
          itemHeight: 18,
          itemsSpacing: 8,
          symbolSize: 10,
          symbolShape: 'circle',
        }]}
        animate={true}
        motionConfig="gentle"
      />
    </ChartCard>
  );
}
